window.$ = window.jQuery = require('jquery');

require('./slick.min.js');
require('./jquery.arcticmodal.js');
require('./jquery.nice-select.min.js');
require('./jquery.marquee.min.js');
	
$(document).ready(function() {
    //marquee
    $('.js-marquee').marquee({
        duration: 20000,
        gap: 0,
        delayBeforeStart: 0,
        direction: 'left',
        duplicated: true,
        duplicateCount: 3,
        startVisible: true
    });

    // fix header
    if($('.js-fixHeader').length > 0) {
        let header = $('.header');
        let lastScroll = 0;
        
        window.addEventListener("scroll", () => {
            let currentScroll = window.pageYOffset;    
            
            if (currentScroll <= 0) {
                header.removeClass('scrolling_up');
                return;
            }

            if (currentScroll > lastScroll && !header.hasClass('scrolling_down')) {
                header.removeClass('scrolling_up');
                header.addClass('scrolling_down');            
                $('.header-logo-scroll').show();
            } else if ( currentScroll < lastScroll && header.hasClass('scrolling_down')) {
                header.removeClass('scrolling_down');
                header.addClass('scrolling_up');
                $('.header-logo-scroll').hide();
                
            }
            lastScroll = currentScroll;
        });
    }

    // burger menu
    function closeBurger() {
        $('.js-headerMobile').hide();

        $('.header').removeClass('opened');
        $('body').removeClass('oveflow');
    }

    function openBurger() {
        $('.js-headerMobile').show();

        $('.header').addClass('opened');
        $('body').addClass('oveflow');
    }

    $('.js-burgerMenu').on('click', function(){
        openBurger();

        return false;
    });

    $('.js-burgerMenuClose').on('click', function(){
        closeBurger();

        return false;
    });

    // scroll to id
    if (window.location.hash) {
        setTimeout(function(){
            scrollToSection(window.location.hash);
        }, 50);
    }

    $('a[href*="#"]').click(function (e) {
      e.preventDefault();
      if (this.pathname === window.location.pathname) {
        scrollToSection(this.hash);
      }
      else {
        window.location.replace(this.href);
      }
    });

    function scrollToSection(id) {
        let header = $('header');
        let hederHeight = header.outerHeight()+28;
        $('html, body').animate({
            scrollTop: $(id).offset().top-hederHeight
        }, 1000);
    }

    // slider
    mobileOnlySlider(".js-whySlider", true, false, 575);

    function mobileOnlySlider($slidername, $dots, $arrows, $breakpoint) {
        var slider = $($slidername);
        var settings = {
            mobileFirst: true,
            dots: $dots,
            arrows: $arrows,
            slide: '.slide',
            responsive: [
            {
                breakpoint: $breakpoint,
                settings: "unslick"
            }
            ]
        };

        slider.slick(settings);

        $(window).on("resize", function () {
            if ($(window).width() > $breakpoint) {
                return;
            }
            if (!slider.hasClass("slick-initialized")) {
                return slider.slick(settings);
            }
        });
    }

    // style first word
    $('.js-intro p').each(function(){
        var val= this.innerHTML;
        val= val.replace(/(\S*)/,'<span>$1</span>');
        this.innerHTML=val;
    });

    // file upload
    function renderUploadState($input) {
        var $box = $input.closest('.drop-btn-left');
        var file = ($input.val() || '').split('\\').pop();

        if (file !== '') {
            $input.hide();
            $box.find('.js-upload-label').hide();
            $box.find('.js-upload-name').remove();
            $box.find('.js-upload-name-container')
                .html('<span class="drop-btn-left-name js-upload-name"></span>')
                .find('.js-upload-name')
                .text(file);
            $box.find('.js-upload-delete').show();
        } else {
            $input.show();
            $box.find('.js-upload-label').show();
            $box.find('.js-upload-name').remove();
            $box.find('.js-upload-delete').hide();
        }
    }

    function resetUpload($input) {
        $input.get(0).value = '';
        $input.trigger('change');
    }

    // Delegated: CF7 may re-create the form DOM after wpcf7domready.
    $(document).on('change', '.js-upload', function() {
        renderUploadState($(this));
    });

    $(document).on('click', '.js-upload-delete', function() {
        $(this).closest('.drop-btn-left').find('.js-upload').each(function() {
            resetUpload($(this));
        });
    });

    // submit form
    var wpcf7Elm = document.querySelector( '.wpcf7' );

    if (wpcf7Elm) {
        wpcf7Elm.addEventListener( 'wpcf7mailsent', function( event ) {
            $(event.target).find('.js-upload, .js-file').each(function() {
                resetUpload($(this));
            });

            $.arcticmodal('close');

            $('#thankyou').arcticmodal();
        }, false );
    }

    // modal windows
    $('.js-modal-link').on('click', function() {
        var t = $(this).attr('modal-target');
        if (!t) {
        t = $(this).attr('href');
        }
        $('.' + t).arcticmodal({
        beforeOpen: function(data, el) {
            $('.main-header').addClass('modal-open');
        },
        afterClose: function(data, el) {
            $('.main-header').removeClass('modal-open');
        }
        });
        return false;
    });

    // form file upload
    $(document).on('change', '.js-file', function(){
        var filename = ($(this).val() || '').split('\\').pop();
        var $block = $(this).closest('.form-file-block');

        if (filename != '') {

        var langCode = $('html').attr('lang');

        if (langCode != 'en-US') {
            $block.find('label').addClass('active').text('Виберіть інший файл');
        } else {
            $block.find('label').addClass('active').text('Choose other file');
        }

        $block.find('span.icon_item').text(filename);
        } else {
        $block.find('label').removeClass('active').text('Choose file');
        $block.find('span.icon_item').text('');
        }
    });

    // show textarea checkbox
    $('.wpcf7-checkbox label input').on('change', function() {
        if ($(this).is(':checked')) {
        $(this).closest('form').find('.form-textarea').show();
        } else {
        $(this).closest('form').find('.form-textarea').hide().find('textarea').val('');
        }
    });

    // vacancies
    var ttlpost = $('.vacancy-title').text();
    $('input[name="post_title"]').val(ttlpost);

    // niceSelect      
    $('select').niceSelect();

    function insertParam(search, key, value) {
        key = encodeURIComponent(key);
        value = encodeURIComponent(value);

        var kvp = search.substr(1).split('&');
        var i = 0;

        for (; i < kvp.length; i++) {
            if (kvp[i].startsWith(key + '=')) {
                let pair = kvp[i].split('=');
                pair[1] = value;
                kvp[i] = pair.join('=');
                break;
            }
        }

        if (i >= kvp.length) {
            kvp[kvp.length] = [key, value].join('=');
        }

        // can return this or...
        var params = kvp.join('&');

        // reload page with new params
        return params;
    }

    $('.js-vacView').click(function () {
        var search = window.location.search;
        var newSearch = insertParam(search, 'view', $(this).data('view'));
        window.location.search = newSearch
    });

    $('.js-vacTag').change(function () {
        var search = window.location.search;        
        var newSearch = insertParam(search, 'vac_tags', $(this).val());

        var langCode = $('html').attr('lang');

        if (langCode == 'en-US') {
            window.location.href = '/en/vacancies/?'+newSearch
        } else {
            window.location.href = '/vacancies/?'+newSearch
        }
    });

    $('.js-vacTag:checked + label').click(function () {
        var search = window.location.search;
        var newSearch = insertParam(search, 'vac_tags', $(this).val());
        
        var langCode = $('html').attr('lang');

        if (langCode == 'en-US') {
            window.location.href = '/en/vacancies/?'+newSearch
        } else {
            window.location.href = '/vacancies/?'+newSearch
        }
    });

    $('.js-infoTag').closest('a').click(function (e) {
        if ($(this).find('.js-infoTag').is(e.target)) {
            e.preventDefault()
            $(location).attr('href', $(this).find('.js-infoTag').data('link'))
        }
    });

    function checkLocation(select){
        if (select.val() !== '') {
            select.parent().addClass('selected');
            select.parent().find('.js-clearLocation').show();
        } else {
            select.parent().removeClass('selected');
            select.parent().find('.js-clearLocation').hide();
        }
    }
    checkLocation($('.js-selectLocation'));
    
    $('.js-selectLocation').on('change', function(){
        checkLocation($(this));
    });
    
    $('.js-clearLocation').on('click', function(){
        $(this).parent().find('.js-selectLocation').val('').niceSelect('update').change();
        $(this).closest('form').submit();
    });
    
    function checkPosition(input){
        if(input.val().length > 0) {
            input.parent().find('.js-clearPosition').show();
        } else {
            input.parent().find('.js-clearPosition').hide();
        }
    }
    checkPosition($('.js-inputPosition'));
    
    $('.js-inputPosition').on('keyup', function(){
        checkPosition($(this));
    });
    
    $('.js-clearPosition').on('click', function(){
        $(this).parent().find('.js-inputPosition').val('');
        $(this).closest('form').submit();
    });

});